import { fetchAgreementsReport } from '../../../agreements/report/fetch-agreements-report';
import { formatAgreementsRecordsToTabularSheet } from '../../formatters/agreements-tabular.formatter';
import { readAgreementsTaskPaneFilterFromDom } from '../../report-input/read-agreements-taskpane-filter.util';
import type { ReportFetchContext, ReportFetchResult } from '../report-fetch.types';
import { completeFetchedReportWithTabularWrite } from '../utils/complete-fetched-report-with-tabular-write.util';

/** Agreements target: DOM → feature fetch → tabular format → shared sheet writer. */
export async function executeAgreementsReportingTargetFetch(
    ctx: ReportFetchContext
): Promise<ReportFetchResult> {
    const filter = readAgreementsTaskPaneFilterFromDom();
    const fetchResult = await fetchAgreementsReport(ctx.accessToken, filter, {
        fetchGetAgreements: (token, payload) =>
            ctx.deps.agreementsApi.fetchGetAgreements(token, payload),
    });
    return completeFetchedReportWithTabularWrite(
        fetchResult,
        formatAgreementsRecordsToTabularSheet,
        (payload, mode) => ctx.deps.tabularSheetWriter.writeTabularSheetToWorksheet(payload, mode),
        ctx.tabularWriteMode
    );
}
